export const SYSTEM_MAIN_FONT: string = 'var(--font-inter), sans-serif'
export const SYSTEM_MODAL_FONT: string = 'Arial, sans-serif'
export const SYSTEM_ROBOTO_FONT: string = "'Roboto', Arial, sans-serif"

export const ZERO_POINT_FIVE_OPACITY: number = 0.5
export const ZERO_POINT_SIX_FIVE_OPACITY: number = 0.65
export const ZERO_POINT_SEVEN_OPACITY: number = 0.7
export const ZERO_POINT_EIGHT_FIVE_OPACITY: number = 0.85
export const ZERO_POINT_NINE_FIVE_OPACITY: number = 0.95

export const SYSTEM_COLOR_DARK_GOLD: string = '#ac9202'
export const SYSTEM_COLOR_GOLD: string = '#ffd700'
export const SYSTEM_GREEN_COLOR: string = '#aefd2f'
export const SYSTEM_COLOR_VIBRANT_ORANGE: string = '#F97316'
export const SYSTEM_BRIGHT_ORANGE_COLOR: string = '#ff8a00'
export const SYSTEM_SUBSCRIPTION_PITCH_SUBSCRIBE_BUTTON_BG_COLOR: string =
  '#f08c00'
export const SYSTEM_DARK_GREEN_COLOR: string = '#008000'
export const SYSTEM_LIGHT_GREEN_COLOR: string = '#009368'
export const SYSTEM_DARK_OLIVE_COLOR: string = '#323200'
export const SYSTEM_SEA_BLUE_COLOR: string = '#1971c2'
export const SYSTEM_ATLANTIC_BLUE_COLOR: string = '#103557'
export const SYSTEM_BRIGHT_SKY_BLUE_COLOR: string = '#43a9f7'
export const SYSTEM_COLOR_ELECTRIC_VIOLET: string = '#A855F7'
export const SYSTEM_PURPLE_COLOR: string = '#8638a9'
export const SYSTEM_ROYAL_PURPLE_COLOR: string = '#4500e5'
export const SYSTEM_COLOR_DARK_BLUE: string = '#00008b'
export const SYSTEM_CYAN_COLOR: string = '#00aabe'
export const SYSTEM_SKY_BLUE_COLOR: string = '#339af0'
export const SYSTEM_DEEP_MIDNIGHT_PURPLE: string = '#110020'
export const SYSTEM_SOFT_LAVENDER: string = '#d6b4fc'
export const SYSTEM_ACCENT_SECONDARY_COLOR: string = '#a993dc'
export const SYSTEM_COLOR_LAVENDER_BLUSH: string = '#fff1fe'
export const SYSTEM_WHITE_COLOR: string = '#ffffff'
export const SYSTEM_WHITE_COLOR_TINGED: string = '#f5f5f5'
export const SYSTEM_COLOR_OFF_WHITE: string = '#e7ddddff'
export const SYSTEM_BLACK_COLOR: string = '#000000'
export const SYSTEM_BLACK_COLOR_TINGED: string = '#111110'
export const SYSTEM_MUTED_BLACK_COLOR: string = '#000612'
export const SYSTEM_MUTED_ALT_BLACK_COLOR: string = '#1a1b1e'
export const SYSTEM_RED_COLOR: string = '#c6231a'
export const SYSTEM_PINK_COLOR: string = '#FFC0CB'
export const SYSTEM_MEDIUM_RED_COLOR: string = '#ff6b6b'
export const SYSTEM_ERROR_STATE_COLOR_PLAYLIST_TIMEPICKERS: string = '#f87171'
export const SYSTEM_LIGHT_RED_COLOR: string = '#ff8a8a'
export const SYSTEM_ORANGE_COLOR: string = '#f25325'
export const SYSTEM_ORANGE_COLOR_VERY_MUTED: string = '#f3e0dc'
export const SYSTEM_COLOR_DEEP_MAROON: string = '#350000'
export const SYSTEM_COLOR_MAUVE_MIST: string = '#DDC5DB'
export const SYSTEM_GRAY_COLOR: string = '#888888'
export const SYSTEM_DARK_GRAY_COLOR: string = '#666666'
export const SYSTEM_DARK_GRAY_COLOR_TINGED: string = '#666980'
export const SYSTEM_LIGHT_GRAY_COLOR: string = '#dad5d5'
export const SYSTEM_DARKER_GRAY_COLOR: string = '#373333'
export const SYSTEM_MUTED_GRAY_COLOR: string = '#464646'
export const SYSTEM_COOL_LIGHT_GRAY_COLOR: string = '#adb5bd'
export const SYSTEM_COLOR_WARM_PEWTER: string = '#D0D0C0'
export const SYSTEM_COLOR_PALE_MAIZE: string = '#ffec99'
export const SYSTEM_COLOR_WISTERIA: string = '#b9a6e6'

export const LIGHT_MODE_BACKGROUND_COLOR: string = SYSTEM_WHITE_COLOR
export const LIGHT_MODE_BACKGROUND_COLOR_TINGED = '#d9eefe'
export const LIGHT_MODE_REGULAR_TEXT_COLOR: string = SYSTEM_BLACK_COLOR
export const LIGHT_MODE_ACTION_COLOR: string = SYSTEM_SKY_BLUE_COLOR
export const LIGHT_MODE_ACCENT_PRIMARY_COLOR: string = SYSTEM_SKY_BLUE_COLOR
export const LIGHT_MODE_ACCENT_PRIMARY_COLOR_DARKER: string = '#0076d6'
export const LIGHT_MODE_ACCENT_SECONDARY_COLOR: string =
  SYSTEM_ACCENT_SECONDARY_COLOR
export const LIGHT_MODE_ACCENT_TERTIARY_COLOR: string = SYSTEM_COLOR_DARK_BLUE
export const LIGHT_MODE_ACCENT_QUATERNARY_COLOR: string = '#ff5722'
export const LIGHT_MODE_ACCENT_QUINARY_COLOR: string = '#a020f0'
export const LIGHT_MODE_X_CLOSE_MODAL_BUTTON_HIGHLIGHT_COLOR: string = '#dae9f7'
export const LIGHT_MODE_LIGHT_GRAY_COLOR: string = SYSTEM_COOL_LIGHT_GRAY_COLOR
export const LIGHT_MODE_DANGER_COLOR: string = SYSTEM_RED_COLOR
export const LIGHT_MODE_PAUSE_BUTTON_COLOR: string = SYSTEM_SKY_BLUE_COLOR
export const LIGHT_MODE_MUTED_REGULAR_TEXT_COLOR: string = '#212529'
export const LIGHT_MODE_MUTED_BORDER_COLOR: string = '#dee2e6'
export const LIGHT_MODE_BUY_CREDITS_SPLASH_BODY_TEXT: string = '#7e7e84'
export const LIGHT_MODE_APPLE_LOGO_COLOR = SYSTEM_BLACK_COLOR
export const LIGHT_MODE_SWITCH_TRACK_COLOR: string = '#a7a7b4'
export const LIGHT_MODE_CLOSE_BUTTON_BACKGROUND_COLOR: string = '#e7f5ff'
export const LIGHT_MODE_CLOSE_BUTTON_TEXT_COLOR: string = '#228be6'

export const DARK_MODE_BACKGROUND_COLOR: string = SYSTEM_BLACK_COLOR
export const DARK_MODE_BLUE_TINGED_BLACK: string = '#2b2c3d'
export const DARK_MODE_BACKGROUND_COLOR_TINGED = '#012949'
export const DARK_MODE_REGULAR_TEXT_COLOR: string = SYSTEM_WHITE_COLOR
export const DARK_MODE_ACTION_COLOR: string = SYSTEM_SKY_BLUE_COLOR
export const DARK_MODE_MUTED_ACTION_COLOR: string = '#2d7cbd'
export const DARK_MODE_MUDDY_GOLD: string = '#0a3558'
export const DARK_MODE_ACCENT_PRIMARY_COLOR: string = SYSTEM_SKY_BLUE_COLOR
export const DARK_MODE_ACCENT_SECONDARY_COLOR: string =
  SYSTEM_ACCENT_SECONDARY_COLOR
export const DARK_MODE_ACCENT_QUATERNARY_COLOR: string = '#ee82ee'
export const DARK_MODE_ACCENT_TERTIARY_COLOR: string = '#ffa500'
export const DARK_MODE_ACCENT_QUINARY_COLOR: string = '#a020f0'
export const DARK_MODE_DANGER_COLOR: string = SYSTEM_MEDIUM_RED_COLOR
export const DARK_MODE_PAUSE_BUTTON_COLOR: string = SYSTEM_SKY_BLUE_COLOR
export const DARK_MODE_MUTED_REGULAR_TEXT_COLOR: string = SYSTEM_WHITE_COLOR
export const DARK_MODE_MUTED_BORDER_COLOR: string = '#373A40'
export const DARK_MODE_APPLE_LOGO_COLOR: string = '#a7a9ab'
export const DARK_MODE_SWITCH_TRACK_COLOR: string = '#2b2c3d'
export const DARK_MODE_CLOSE_BUTTON_BACKGROUND_COLOR: string = '#051727'
export const DARK_MODE_CLOSE_BUTTON_TEXT_COLOR: string = '#a5d8ff'
